function initQtip()
{
    $(document).find(".qtip-handle").each(function () {
            if ($(this).attr('data-hasqtip')) {
                return;
            }

            let href = $(this).attr('data-href');

            let myPosition = 'top right';

            if (isDefined($(this).data('my-position'))) {
                myPosition = $(this).data('my-position');
            }

            $(this).qtip({
                    content: {
                        text: 'Načítám...', // Loading text...
                        ajax: {
                            url: href,
                            type: 'GET',
                            success: function (data, status) {
                                this.set('content.text', data.html);
                            }
                        }
                    },
                    style: {
                        classes: 'qtip-bootstrap'
                    },
                    position: {
                        my: myPosition,  // Position my top left...
                    },
                    show: {
                        delay: 100
                    },
                    hide: {
                        fixed: true,
                        delay: 100
                    }
                }
            );
        }
    );
}

$(document).ready(function () {
    initQtip();
});

$(document).ajaxComplete(function () {
    initQtip();
});